import { Alert, Button, Stack, Typography } from "@mui/material";
import { AlertSeverity } from "src/components/SeverityStatus";
import InvertedExclamationIcon from "src/assets/inverted_exclamation.svg";

export const Header = ({
  itemIsValid,
  handler,
  name,
  sx
}: any) => (
    <Stack sx={{ ...sx }} direction="row" display="flex" spacing={1} alignItems="center">
      <Typography variant="h6">{name}</Typography>
      <Alert 
        severity={itemIsValid ? AlertSeverity.SUCCESS : AlertSeverity.INFO} 
        icon={false}
        sx={{
          height: '30px',
          fontSize: '0.75rem',
          textTransform: 'capitalize',
          cursor: 'pointer',
          alignItems: 'center',
          padding: 1,
          ml: -1,
          fontWeight: 'bold'
        }}
      >
        {itemIsValid ? 'Completed': 'In-Progress'}
      </Alert>
      <Button 
        sx={{ backgroundColor: 'rgba(0, 184, 217, 0)', minWidth: '26px' }} 
        onClick={handler} 
        size="small" 
        autoFocus={false} 
      >
        <InvertedExclamationIcon color='#00b8d9'/>
      </Button>
    </Stack>
  );

